import React, { useEffect, useLayoutEffect } from 'react';

const FONT_HREF = 'https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@500,700,800,900&f[]=satoshi@400,500,700&display=swap';
const ARTIFACT_STYLE = `
    :root{
      --bg:#f7f4ee;
      --paper:#fffdfa;
      --paper-2:#fbfaf6;
      --card:#ffffff;
      --line:#e5e1d8;
      --text:#0f2038;
      --muted:#64748b;
      --muted-2:#7c8aa0;
      --navy:#10243f;
      --navy-2:#173355;
      --teal:#2c9ca0;
      --teal-2:#daf1ef;
      --gold:#d89a2b;
      --gold-2:#f5e1b6;
      --mint:#eff9f7;
      --shadow:0 18px 50px rgba(16,36,63,.08);
      --radius:22px;
      --radius-sm:14px;
      --container:1460px;
    }

    *{box-sizing:border-box}
    html{scroll-behavior:smooth}
    body{
      margin:0;
      font-family:'Satoshi',system-ui,-apple-system,sans-serif;
      color:var(--text);
      background:
        radial-gradient(circle at 0% 0%, rgba(44,156,160,.05), transparent 26%),
        radial-gradient(circle at 100% 0%, rgba(216,154,43,.06), transparent 20%),
        var(--bg);
    }
    a{text-decoration:none;color:inherit}
    button,input,select{font:inherit}
    .auth-card{position:absolute;top:24px;right:26px;width:210px;background:rgba(10,15,30,.25);backdrop-filter:blur(16px);border-radius:16px;padding:18px 18px 16px;box-shadow:0 16px 40px rgba(10,15,30,.2);border:1px solid rgba(255,255,255,.12);z-index:3}
    .auth-card-label{font-size:8px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:var(--gold);margin-bottom:5px}
    .auth-card-title{font-family:'Cabinet Grotesk',sans-serif;font-size:15px;font-weight:800;color:#fff;margin-bottom:2px;line-height:1.1}
    .auth-card-sub{font-size:10px;color:rgba(255,255,255,.38);margin-bottom:13px}
    .auth-role-btns{display:flex;flex-direction:column;gap:6px;margin-bottom:11px}
    .auth-role-btn{display:flex;align-items:center;gap:9px;padding:8px 12px;border-radius:8px;border:none;cursor:pointer;font-size:12px;font-weight:700;font-family:'Satoshi',sans-serif;background:rgba(255,255,255,.08);color:#fff;transition:background .2s}
    .auth-role-btn:hover{background:rgba(255,255,255,.15)}
    .auth-role-btn--gold{background:var(--gold);color:var(--navy)}
    .auth-role-btn--gold:hover{background:#f0aa30}
    .auth-role-icon{font-size:13px}
    .auth-divider{display:flex;align-items:center;gap:6px;margin-bottom:10px}
    .auth-divider::before,.auth-divider::after{content:'';flex:1;height:1px;background:rgba(255,255,255,.1)}
    .auth-divider span{font-size:9px;color:rgba(255,255,255,.28);white-space:nowrap}
    .auth-signin-btn{width:100%;padding:8px;border-radius:8px;border:1px solid rgba(255,255,255,.15);background:transparent;color:rgba(255,255,255,.7);font-size:12px;font-weight:700;font-family:'Satoshi',sans-serif;cursor:pointer;transition:all .2s}
    .auth-signin-btn:hover{background:rgba(255,255,255,.08);color:#fff}
    /* LIGHTBOX */
    #ch-lightbox{display:none;position:fixed;inset:0;z-index:1000;background:rgba(10,15,30,.75);backdrop-filter:blur(8px);align-items:center;justify-content:center;padding:20px}
    .ch-lbx-card{background:#fff;border-radius:20px;padding:36px;width:100%;max-width:420px;box-shadow:0 40px 100px rgba(10,15,30,.4);position:relative}
    .ch-lbx-close{position:absolute;top:16px;right:18px;background:none;border:none;font-size:22px;cursor:pointer;color:#667085;line-height:1}
    .ch-lbx-title{font-family:'Cabinet Grotesk',sans-serif;font-size:22px;font-weight:800;color:var(--navy);margin-bottom:4px}
    .ch-lbx-sub{font-size:13px;color:#667085;margin-bottom:20px}
    .ch-lbx-tabs{display:flex;gap:8px;margin-bottom:20px}
    .ch-lbx-tab{flex:1;padding:8px;border-radius:8px;border:1.5px solid #e4e0d8;background:#f8f8f6;font-size:12px;font-weight:700;cursor:pointer;color:#667085;transition:all .2s}
    .ch-lbx-tab.active{border-color:var(--navy);background:var(--navy);color:#fff}
    .ch-lbx-field{display:flex;flex-direction:column;gap:4px;margin-bottom:12px}
    .ch-lbx-field label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--navy)}
    .ch-lbx-field input{padding:10px 12px;border-radius:8px;border:1.5px solid #e4e0d8;background:#f8f8f6;font-size:13px;color:var(--navy);font-family:'Satoshi',sans-serif}
    .ch-lbx-btn{width:100%;padding:13px;border-radius:8px;border:none;background:var(--navy);color:#fff;font-size:13px;font-weight:800;font-family:'Satoshi',sans-serif;cursor:pointer;margin-top:8px;transition:background .2s}
    .ch-lbx-btn:hover{background:var(--gold);color:var(--navy)}
    .ch-lbx-switch{text-align:center;font-size:12px;color:#667085;margin-top:14px}
    .ch-lbx-switch a{color:var(--navy);font-weight:700;cursor:pointer}
    img{max-width:100%;display:block}
    .container{width:min(calc(100% - 40px), var(--container));margin:0 auto}
    .eyebrow{
      display:inline-flex; align-items:center; gap:10px;
      font-size:12px; font-weight:800; letter-spacing:.14em; text-transform:uppercase;
      color:var(--teal);
    }
    .eyebrow::before{
      content:""; width:26px; height:2px; background:var(--teal); border-radius:2px;
    }

    /* HEADER */
    .site-header{
      position:sticky; top:0; z-index:40;
      background:rgba(255,253,250,.88);
      backdrop-filter: blur(14px);
      border-bottom:1px solid rgba(229,225,216,.85);
    }
    .header-row{
      min-height:78px; display:flex; align-items:center; justify-content:space-between; gap:24px;
    }
    .brand{
      display:flex; align-items:center; gap:14px; font-weight:900; font-size:21px;
    }
    .brand-mark{
      width:40px; height:40px; border-radius:999px;
      display:grid; place-items:center; background:var(--navy); color:#fff; font-weight:800;
      box-shadow:var(--shadow);
    }
    .nav-links{
      display:flex; align-items:center; gap:28px; font-size:14px; color:#334155; font-weight:600;
    }
    .nav-links a.active{
      color:var(--navy); position:relative;
    }
    .nav-links a.active::after{
      content:""; position:absolute; left:0; right:0; bottom:-28px; height:3px;
      background:var(--gold); border-radius:999px;
    }
    .header-actions{display:flex; gap:12px; align-items:center}
    .btn{
      border:0; outline:0; border-radius:12px; padding:13px 18px; font-weight:700;
      cursor:pointer; transition:.2s ease transform, .2s ease box-shadow, .2s ease background;
    }
    .btn:hover{transform:translateY(-1px)}
    .btn-gold{background:var(--gold); color:#24190a}
    .btn-outline{background:#fff; color:var(--navy); border:1px solid #cbd5e1}
    .btn-light{background:#fff; color:var(--navy); border:1px solid var(--line)}
    .btn-teal{background:var(--teal); color:#fff}
    .btn-sm{padding:10px 14px; font-size:13px; border-radius:10px}
    .mobile-menu{display:none}

    /* HERO */
    .hero{
      padding:28px 0 18px;
    }
    .hero-shell{
      position:relative;
      background:
        linear-gradient(90deg, rgba(8,18,33,.55) 0%, rgba(8,18,33,.22) 50%, rgba(8,18,33,.04) 100%),
        url("https://ik.imagekit.io/enrollforge/careerhub/herocareerhub.webp") top center / cover no-repeat;
      border:1px solid #ddd8ce;
      border-radius:34px;
      min-height:470px;
      overflow:hidden;
      box-shadow:var(--shadow);
    }
    .hero-grid{
      position:relative;
      display:grid;
      grid-template-columns: 1.02fr .98fr;
      min-height:470px;
    }
    .hero-copy{
      padding:54px 52px 120px;
      position:relative; z-index:2;
    }
    .hero-copy h1{
      font-family:'Cabinet Grotesk', sans-serif;
      font-weight:800;
      margin:18px 0 18px;
      font-size:72px;
      line-height:.96;
      letter-spacing:-0.015em;
      color:#fff;
      max-width:640px;
    }
    .hero-copy h1 .accent{color:#E8A020; font-style:italic}
    .hero-copy p{
      margin:0 0 28px;
      max-width:560px;
      color:#f2f5f8;
      font-size:22px;
      line-height:1.45;
      font-weight:500;
    }
    .hero-figure{
      position:relative;
      min-height:470px;
      background:
        radial-gradient(circle at 60% 20%, rgba(255,255,255,.4), transparent 20%),
        radial-gradient(circle at 85% 78%, rgba(44,156,160,.18), transparent 20%);
    }
    .hero-portrait{
      position:absolute; right:24px; bottom:0; width:84%; height:100%;
      border-radius:0;
      background:none;
    }
    .hero-portrait::before{
      content:"";
      position:absolute; inset:auto 18px 18px auto;
      padding:8px 12px; border-radius:999px;
      background:rgba(16,36,63,.7); color:#fff; font-size:12px;
      backdrop-filter:blur(6px);
    }

    .hero-search{
      position:absolute; left:38px; right:50%; bottom:28px;
      display:grid; grid-template-columns: 1.6fr 0.7fr 0.85fr auto;
      gap:10px; background:#fff; padding:12px; border-radius:22px;
      box-shadow:0 16px 40px rgba(16,36,63,.18);
      z-index:3;
    }
    .field{
      display:flex; align-items:center; gap:12px; padding:14px 16px;
      border:1px solid var(--line); border-radius:14px; background:#fff;
      color:#334155;
    }
    .field .icon{
      width:18px; height:18px; opacity:.7;
    }
    .field input, .field select{
      width:100%; border:0; outline:0; background:transparent; color:#334155;
    }
    .field input[placeholder="State"]{
      max-width:80px;
    }
    .hero-tags{ display:none !important; }
    .match-card{
      position:absolute; right:26px; top:34px; width:280px;
      background:#fff; border:1px solid #e3e8ee; border-radius:22px; padding:20px;
      box-shadow:0 18px 40px rgba(16,36,63,.12); z-index:3;
    }
    .match-top{
      display:flex; justify-content:space-between; align-items:center; margin-bottom:14px;
      font-weight:800; color:var(--navy);
    }
    .match-list{display:grid; gap:10px}
    .match-item{
      display:grid; grid-template-columns: 36px 1fr auto; gap:12px; align-items:center;
      padding:10px 0; border-bottom:1px solid #edf2f7;
    }
    .match-item:last-child{border-bottom:0}
    .match-icon{
      width:36px; height:36px; border-radius:12px; display:grid; place-items:center;
      background:#f1f7fb; color:var(--navy); font-size:16px;
    }
    .match-item b{display:block; font-size:14px}
    .match-item span{display:block; color:var(--muted); font-size:12px; margin-top:3px}
    .match-score{
      font-weight:800; color:var(--teal); background:#edf9f8; padding:8px 10px; border-radius:10px; font-size:12px;
    }

    /* QUICK ACTIONS */
    .quick-actions{
      padding:16px 0 22px;
    }
    .quick-actions .bar{
      background:#f3faf9; border:1px solid #dcefeb; border-radius:22px;
      padding:12px; display:grid; grid-template-columns:repeat(5,1fr); gap:10px;
    }
    .quick-action{
      background:transparent; border:1px solid transparent; border-radius:16px; padding:14px;
      display:flex; gap:12px; align-items:flex-start; transition:.2s ease;
    }
    .quick-action:hover{
      background:#fff; border-color:#dcefeb; transform:translateY(-1px);
    }
    .quick-action .qa-icon{
      width:38px; height:38px; border-radius:12px; background:#e8f7f5; color:var(--teal);
      display:grid; place-items:center; font-weight:900; flex:0 0 auto;
    }
    .quick-action b{display:block; font-size:14px; margin-bottom:4px}
    .quick-action span{font-size:12px; color:var(--muted)}

    /* Generic sections */
    section.block{padding:18px 0}
    .section-head{
      display:flex; align-items:end; justify-content:space-between; gap:16px; margin-bottom:16px;
    }
    .section-head h2{
      margin:0 0 8px; font-family:'Cabinet Grotesk', sans-serif; font-size:46px; letter-spacing:-.04em;
    }
    .section-head p{margin:0; color:var(--muted); font-size:15px}
    .section-link{font-weight:700; color:var(--teal); white-space:nowrap}
    .card{
      background:var(--card); border:1px solid var(--line); border-radius:var(--radius);
      box-shadow:var(--shadow);
    }

    /* Opportunity VI */
    .vi-tabs{
      display:grid; grid-template-columns: repeat(6,1fr); gap:10px; margin-bottom:14px;
    }
    .vi-tab{
      border:1px solid var(--line); background:#fff; border-radius:16px; padding:16px 18px;
      display:flex; align-items:center; gap:10px; cursor:pointer; font-weight:700; color:#334155;
      transition:.2s ease;
    }
    .vi-tab.active{
      border-color:var(--teal); color:var(--teal); box-shadow:0 0 0 2px rgba(44,156,160,.08) inset;
    }
    .vi-tab-icon{
      width:28px; height:28px; border-radius:10px; display:grid; place-items:center; background:#f4f7fb;
      font-size:14px;
    }
    .vi-body{
      display:grid; grid-template-columns: 1.1fr 2fr; gap:16px;
    }
    .vi-feature, .vi-jobs{
      background:#fff; border:1px solid var(--line); border-radius:24px; overflow:hidden;
    }
    .vi-feature{
      display:grid; grid-template-columns: 190px 1fr;
      min-height:268px;
    }
    .feature-photo{
      background:
        url("https://ik.imagekit.io/enrollforge/careerhub/edusector.webp") center/cover no-repeat,
        linear-gradient(135deg, #d6ddd8, #f1f3ef);
      position:relative;
    }
    .feature-photo::before{ content:none; }
    .feature-copy{padding:24px}
    .feature-copy h3{
      margin:8px 0 10px; font-family:'Cabinet Grotesk', sans-serif; font-size:34px; line-height:1.05;
    }
    .feature-copy p{margin:0 0 16px; color:var(--muted); line-height:1.6}
    .mini-link{color:var(--teal); font-weight:700}
    .vi-jobs{
      padding:18px; display:grid; grid-template-columns: repeat(3,1fr); gap:14px;
    }
    .job-card{
      border:1px solid var(--line); border-radius:18px; padding:18px;
      display:flex; flex-direction:column; gap:10px;
      background:linear-gradient(180deg,#fff,#fefdf9);
    }
    .job-card .label{
      align-self:flex-start; background:#fff7e6; color:var(--gold); border:1px solid #f5deb0;
      padding:6px 10px; border-radius:999px; font-size:11px; font-weight:800; letter-spacing:.08em;
      text-transform:uppercase;
    }
    .job-card h4{margin:0; font-size:23px; line-height:1.14}
    .job-card .org{color:var(--muted); font-size:14px; line-height:1.5}
    .job-meta{display:flex; justify-content:space-between; gap:8px; align-items:center; margin-top:auto}
    .salary{font-weight:800; color:var(--navy)}
    .badge-soft{
      padding:6px 10px; border-radius:999px; font-size:12px; font-weight:700;
      background:#ecfaf8; color:var(--teal);
    }

    /* Map + nearby jobs */
    .jobs-grid{
      display:grid; grid-template-columns: 1.05fr 1.55fr; gap:16px;
    }
    .map-panel{
      background:#eef6f5; border:1px solid #dcefeb; border-radius:24px; padding:18px; min-height:320px;
      position:relative; overflow:hidden;
    }
    .map-frame{
      position:absolute; inset:18px 18px 64px;
      border-radius:20px; background:
        linear-gradient(0deg, rgba(255,255,255,.4), rgba(255,255,255,.4)),
        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'><rect width='800' height='500' fill='%23f9fafb'/><g stroke='%23d6dde5' stroke-width='2'><path d='M78 101l108-44 64 17 95-30 84 28 123-18 67 52-27 42 42 22-12 42 41 32-47 29-72-9-51 45-112 5-112-41-61 19-56-39-67-4-30-41 20-52-32-43z' fill='%23eef2f5'/></g><g stroke='%23dfe7ee'><path d='M0 70h800M0 140h800M0 210h800M0 280h800M0 350h800M0 420h800'/><path d='M90 0v500M180 0v500M270 0v500M360 0v500M450 0v500M540 0v500M630 0v500M720 0v500'/></g></svg>") center/cover no-repeat;
      border:1px solid #d8e4e7;
    }
    .pin{
      position:absolute; width:46px; height:46px; border-radius:999px; background:var(--teal); color:#fff;
      display:grid; place-items:center; font-weight:800; box-shadow:0 10px 22px rgba(44,156,160,.25);
      border:4px solid rgba(255,255,255,.9);
    }
    .pin.p1{left:30px; top:118px}
    .pin.p2{left:60px; top:220px}
    .pin.p3{left:190px; top:158px}
    .pin.p4{left:336px; top:238px}
    .pin.p5{right:46px; top:112px}
    .pin.p6{right:160px; top:264px}
    .pin.p7{right:228px; top:162px}
    .map-cta{
      position:absolute; left:20px; bottom:18px;
    }

    .nearby{
      background:#fff; border:1px solid var(--line); border-radius:24px; padding:18px 18px 10px;
    }
    .nearby-head{
      display:flex; justify-content:space-between; gap:12px; align-items:start; margin-bottom:10px;
    }
    .nearby-head h3{
      margin:0 0 4px; font-family:'Cabinet Grotesk', sans-serif; font-size:34px;
    }
    .nearby-head p{margin:0; color:var(--muted)}
    .nearby-list{display:grid; gap:10px}
    .nearby-item{
      display:grid; grid-template-columns: 44px 1.3fr .9fr auto auto; gap:14px; align-items:center;
      border:1px solid #edf2f7; padding:12px 14px; border-radius:18px;
    }
    .nearby-logo{
      width:44px; height:44px; border-radius:12px; background:#eff6ff; display:grid; place-items:center;
      font-size:18px; color:var(--navy);
    }
    .nearby-role b{display:block; font-size:16px}
    .nearby-role span,.nearby-loc{font-size:13px; color:var(--muted)}
    .apply-col{text-align:right}
    .apply-col .salary{display:block; margin-bottom:7px}
    .bookmark{
      width:40px;height:40px;border-radius:12px;border:1px solid var(--line);display:grid;place-items:center;background:#fff;
    }

    /* HOTLIST */
    .hotlist{
      background:linear-gradient(135deg,#0f2745,#0b223e 65%, #173355);
      color:#fff; border:1px solid #173a62; border-radius:26px; padding:18px;
      box-shadow:0 16px 34px rgba(16,36,63,.18);
    }
    .hotlist-head{
      display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:14px;
    }
    .hotlist-title{
      display:flex; gap:14px; align-items:center; font-weight:800;
    }
    .hot-badge{
      display:inline-flex; align-items:center; gap:8px;
      color:#ffcd69; font-weight:800; text-transform:uppercase; letter-spacing:.08em;
    }
    .hot-cards{display:grid; grid-template-columns:repeat(4,1fr); gap:12px}
    .hot-card{
      background:rgba(255,255,255,.03); border:1px solid rgba(255,255,255,.12);
      border-radius:18px; padding:16px; display:grid; grid-template-columns:58px 1fr; gap:14px; align-items:start;
    }
    .seal{
      width:58px; height:58px; border-radius:16px; background:#fff; color:var(--navy);
      display:grid; place-items:center; font-weight:900;
    }
    .hot-card .small{font-size:12px; color:#b9c8db}
    .hot-card h4{margin:4px 0 6px; font-size:20px; line-height:1.15}
    .hot-card .salary{color:#ffcd69}

    /* Tools */
    .tools-grid{
      display:grid; grid-template-columns:repeat(7,1fr); gap:12px;
    }
    .tool{
      background:#fff; border:1px solid var(--line); border-radius:18px; padding:18px 16px;
      min-height:122px;
    }
    .tool .ico{
      width:42px; height:42px; border-radius:12px; background:#eef8f8; color:var(--teal);
      display:grid; place-items:center; font-weight:900; margin-bottom:12px;
    }
    .tool b{display:block; font-size:15px; margin-bottom:6px}
    .tool span{display:block; color:var(--muted); font-size:13px; line-height:1.45}

    /* Ebook */
    .resource{
      display:grid; grid-template-columns: 1.05fr 1.45fr;
      background:#fffefb; border:1px solid #ecdcc0; border-radius:28px; overflow:hidden;
      box-shadow:var(--shadow);
    }
    .resource-photo{
      min-height:340px;
      background:
        url("https://ik.imagekit.io/enrollforge/careerhub/aceinterview.webp") center/cover no-repeat,
        linear-gradient(135deg,#ddd5ca,#f5efe6);
      position:relative;
    }
    .resource-photo::before{ content:none; }
    .resource-copy{
      display:grid; grid-template-columns: 1.3fr .9fr; gap:20px; padding:26px 26px 24px;
      align-items:center;
    }
    .resource-copy h3{
      margin:8px 0 10px; font-family:'Cabinet Grotesk', sans-serif; font-size:48px; line-height:1.03;
    }
    .resource-copy p{margin:0 0 18px; color:var(--muted); font-size:15px; line-height:1.65}
    .book-mock{
      display:grid; grid-template-columns: 180px 1fr; gap:18px; align-items:center;
    }
    .book{
      height:250px; border-radius:12px;
      background:linear-gradient(160deg,#fff,#f4efe6);
      border:2px solid #d7b36d; position:relative; box-shadow:0 24px 28px rgba(16,36,63,.09);
      padding:18px;
    }
    .book .book-title{
      font-family:'Cabinet Grotesk', sans-serif; font-size:26px; line-height:1.1; color:var(--navy);
    }
    .bullet-list{display:grid; gap:12px; font-size:14px; color:#334155}
    .bullet-list .row{display:flex; gap:10px; align-items:flex-start}
    .check{
      width:22px; height:22px; border-radius:999px; background:#fff7e6; color:var(--gold);
      display:grid; place-items:center; font-size:13px; flex:0 0 auto; margin-top:1px;
    }

    /* First briefcase */
    .briefcase{
      background:#eefaf8; border:1px solid #d8eeea; border-radius:26px; padding:20px;
    }
    .briefcase-grid{
      display:grid; grid-template-columns: 1.1fr repeat(4, .7fr) .95fr; gap:12px; align-items:stretch;
    }
    .brief-intro h3{
      margin:8px 0 10px; font-family:'Cabinet Grotesk', sans-serif; font-size:40px; line-height:1.02;
    }
    .brief-intro p{margin:0; color:var(--muted); line-height:1.65}
    .brief-item, .brief-partner{
      background:#fff; border:1px solid #dcefeb; border-radius:18px; padding:18px;
    }
    .brief-item .ico, .brief-partner .ico{
      width:40px;height:40px;border-radius:12px;background:#ecfaf8;color:var(--teal);display:grid;place-items:center;font-weight:900;margin-bottom:12px;
    }
    .brief-item b, .brief-partner b{display:block; font-size:15px; margin-bottom:6px}
    .brief-item span, .brief-partner span{display:block; color:var(--muted); font-size:13px; line-height:1.45}

    /* Employer */
    .employer-grid{
      display:grid; grid-template-columns: .9fr 1.25fr .85fr; gap:16px;
    }
    .employer-copy, .employer-board, .employer-photo{
      background:#fff; border:1px solid var(--line); border-radius:26px; padding:22px;
      min-height:290px;
    }
    .employer-copy h3{
      margin:8px 0 10px; font-family:'Cabinet Grotesk', sans-serif; font-size:40px; line-height:1.03;
    }
    .employer-copy p{margin:0 0 16px; color:var(--muted); line-height:1.65}
    .check-list{display:grid; gap:10px; margin:16px 0 22px}
    .check-list .item{display:flex; gap:10px; align-items:flex-start; color:#334155}
    .dot{
      width:20px; height:20px; border-radius:999px; background:#ecfaf8; color:var(--teal);
      display:grid; place-items:center; font-size:12px; margin-top:2px; flex:0 0 auto;
    }
    .employer-board{
      padding:18px;
    }
    .dash-title{
      display:flex; justify-content:space-between; align-items:center; margin-bottom:12px; color:var(--navy); font-weight:800;
    }
    .metrics{display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:12px}
    .metric{
      border:1px solid #edf2f7; border-radius:16px; padding:14px; background:#fff;
    }
    .metric span{display:block; color:var(--muted); font-size:12px; margin-bottom:8px}
    .metric b{display:block; font-size:28px}
    .pipeline{
      border:1px solid #edf2f7; border-radius:18px; padding:18px; background:#fbfdff;
    }
    .pipeline-head{display:flex; justify-content:space-between; gap:16px; margin-bottom:18px}
    .bars{
      display:grid; grid-template-columns:repeat(5,1fr); gap:10px; align-items:end; min-height:126px;
    }
    .bar-col{
      display:flex; flex-direction:column; justify-content:end; gap:8px;
      font-size:12px; color:var(--muted); text-align:center;
    }
    .bar{
      width:100%; border-radius:12px 12px 6px 6px; background:linear-gradient(180deg,#6fd0ce,#2c9ca0);
    }
    .legend{
      display:grid; gap:8px; margin-top:14px; font-size:13px; color:#334155
    }
    .legend .line{display:flex; align-items:center; gap:10px}
    .swatch{width:12px; height:12px; border-radius:999px}
    .employer-photo{
      padding:0; overflow:hidden; position:relative;
      background:
        url("https://ik.imagekit.io/enrollforge/careerhub/employer.webp") center/cover no-repeat,
        linear-gradient(135deg,#d9d4c8,#f2efe6);
    }
    .employer-photo::before{ content:none; }

    /* testimonials */
    .trust-grid{
      display:grid; grid-template-columns: .95fr repeat(3,.85fr) 1.05fr; gap:16px; align-items:stretch;
    }
    .trust-intro, .quote-card, .logos-card{
      background:#fff; border:1px solid var(--line); border-radius:24px; padding:22px;
    }
    .trust-intro h3{
      margin:0 0 12px; font-family:'Cabinet Grotesk', sans-serif; font-size:34px; line-height:1.08;
    }
    .trust-intro p{margin:0 0 16px; color:var(--muted)}
    .quote-card{
      display:grid; grid-template-rows:auto 1fr auto; gap:14px;
    }
    .person{display:flex; align-items:center; gap:12px}
    .avatar{
      width:54px; height:54px; border-radius:999px; background:linear-gradient(135deg,#cdd8e6,#eff3f8);
      border:1px solid #e2e8f0;
    }
    .quote-card blockquote{
      margin:0; font-size:15px; color:#334155; line-height:1.65;
    }
    .quote-meta b{display:block}
    .quote-meta span{display:block; color:var(--muted); font-size:13px}
    .logos-card h4{
      margin:0 0 14px; font-family:'Cabinet Grotesk', sans-serif; font-size:26px;
    }
    .logos{
      display:grid; grid-template-columns:repeat(2,1fr); gap:10px;
    }
    .logo-box{
      min-height:68px; border:1px solid #edf2f7; border-radius:16px;
      display:grid; place-items:center; font-weight:800; color:#334155;
      background:#fafcff;
    }

    /* footer */
    .site-footer{
      margin-top:14px;
      background:linear-gradient(135deg,#103447,#0f6d73);
      color:#fff;
      overflow:hidden;
    }
    .footer-top{
      padding:26px 0;
      border-top:1px solid rgba(255,255,255,.12);
      border-bottom:1px solid rgba(255,255,255,.12);
    }
    .footer-grid{
      display:grid; grid-template-columns:1.2fr repeat(4,.8fr) 1.1fr; gap:20px;
      align-items:start;
    }
    .footer-brand .brand-mark{background:#fff; color:var(--navy)}
    .footer-brand p{
      color:rgba(255,255,255,.85); line-height:1.65; font-size:14px; margin:14px 0 16px;
      max-width:320px;
    }
    .socials{display:flex; gap:10px}
    .social{
      width:34px; height:34px; border-radius:999px; border:1px solid rgba(255,255,255,.18); display:grid; place-items:center;
      color:#fff;
    }
    .footer-col h5{margin:8px 0 14px; font-size:15px}
    .footer-col a{
      display:block; color:rgba(255,255,255,.82); margin:0 0 10px; font-size:14px;
    }
    .footer-photo{
      min-height:180px;
      border-radius:22px;
      background:
        url("FOOTER_PEOPLE_IMAGEKIT_URL") center/cover no-repeat,
        linear-gradient(135deg,#d2d9d5,#f0f5f3);
      position:relative;
    }
    .footer-photo::before{
      content:"Replace footer collage";
      position:absolute; left:14px; bottom:14px; padding:8px 12px;
      border-radius:999px; background:rgba(16,36,63,.7); color:#fff; font-size:12px;
    }
    .footer-bottom{
      padding:18px 0 28px; color:rgba(255,255,255,.78); font-size:13px; display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap;
    }

    /* utility */
    .muted{color:var(--muted)}
    .mt-6{margin-top:6px}
    .mt-8{margin-top:8px}
    .mt-10{margin-top:10px}
    .mt-16{margin-top:16px}
    .mt-18{margin-top:18px}
    .mt-20{margin-top:20px}
    .mb-0{margin-bottom:0}

    /* responsive */
    @media (max-width: 1280px){
      .hero-grid{grid-template-columns:1fr}
      .hero-copy{padding-right:52px}
      .hero-copy h1{font-size:58px}
      .hero-search{position:static; margin:0 24px 24px; grid-template-columns:1fr 1fr 1fr auto}
      .hero-tags{position:static; padding:0 24px 20px 52px}
      .match-card{right:18px; top:18px; width:260px}
      .hero-figure{min-height:300px}
      .hero-portrait{width:58%; right:0}
      .vi-tabs{grid-template-columns:repeat(3,1fr)}
      .vi-body, .jobs-grid, .resource, .employer-grid, .briefcase-grid, .trust-grid, .footer-grid{grid-template-columns:1fr}
      .quick-actions .bar, .hot-cards, .tools-grid{grid-template-columns:repeat(2,1fr)}
      .resource-copy{grid-template-columns:1fr}
      .nearby-item{grid-template-columns:44px 1fr .9fr auto}
      .bookmark{display:none}
    }

    @media (max-width: 860px){
      .container{width:min(calc(100% - 24px), var(--container))}
      .nav-links,.header-actions{display:none}
      .mobile-menu{display:grid; place-items:center; width:42px;height:42px;border:1px solid var(--line);border-radius:12px;background:#fff}
      .hero-copy{padding:30px 22px 18px}
      .hero-copy h1{font-size:44px}
      .hero-copy p{font-size:17px}
      .match-card{position:static; width:auto; margin:18px 18px 0}
      .hero-search{grid-template-columns:1fr; margin:12px}
      .hero-tags{padding:0 16px 16px; gap:8px}
      .quick-actions .bar, .vi-tabs, .hot-cards, .tools-grid{grid-template-columns:1fr}
      .vi-feature{grid-template-columns:1fr}
      .vi-jobs{grid-template-columns:1fr}
      .metrics{grid-template-columns:repeat(2,1fr)}
      .nearby-item{grid-template-columns:44px 1fr}
      .apply-col{justify-self:start; text-align:left}
      .nearby-loc{display:none}
      .section-head h2,.feature-copy h3,.nearby-head h3,.resource-copy h3,.brief-intro h3,.employer-copy h3,.trust-intro h3{font-size:30px}
      .resource-photo{min-height:240px}
      .book-mock{grid-template-columns:1fr}
      .footer-bottom{flex-direction:column}
    }
  `;
const MAIN_HTML = `
    <!-- HERO -->
    <section class="hero">
      <div class="container">
        <div class="hero-shell">
          <div class="hero-grid">
            <div class="hero-copy">
              <div style="font-size:24px;font-weight:800;color:#E8A020;letter-spacing:.02em;margin-bottom:8px;">Career Hub</div>
              <h1>Find your next <span class="accent">opportunity.</span></h1>
              <p>Curated career opportunities, real advice, and tools that match your goals — and move you forward.</p>
            </div>

            <div class="hero-figure">
              <div class="hero-portrait" aria-hidden="true"></div>

              <aside class="auth-card" id="career-hub-join" aria-label="Join Career Hub">
                <div class="auth-card-label">Get Started</div>
                <div class="auth-card-title">Join Career Hub</div>
                <div class="auth-card-sub">Free. No paywalls. No spam.</div>
                <div class="auth-role-btns">
                  <button class="auth-role-btn" onclick="document.getElementById('ch-lightbox').dataset.mode='seeker-register'; document.getElementById('ch-lightbox').style.display='flex'">
                    <span class="auth-role-icon">👤</span>
                    <span>Job Seeker</span>
                  </button>
                  <button class="auth-role-btn auth-role-btn--gold" onclick="document.getElementById('ch-lightbox').dataset.mode='employer-register'; document.getElementById('ch-lightbox').style.display='flex'">
                    <span class="auth-role-icon">🏢</span>
                    <span>Employer</span>
                  </button>
                </div>
                <div class="auth-divider"><span>Already a member?</span></div>
                <button class="auth-signin-btn" onclick="document.getElementById('ch-lightbox').dataset.mode='signin'; document.getElementById('ch-lightbox').style.display='flex'">
                  Sign In →
                </button>
              </aside>
            </div>
          </div>

          <div class="hero-tags">
            <div class="label">Popular searches:</div>
            <span class="tag">Remote</span>
            <span class="tag">AI &amp; Tech</span>
            <span class="tag">Entry Level</span>
            <span class="tag">Healthcare</span>
            <span class="tag">Government</span>
            <span class="tag">Veterans</span>
          </div>

          <form class="hero-search">
            <label class="field">
              <input type="text" placeholder="Job title, keyword, or company" />
            </label>
            <label class="field">
              <input type="text" placeholder="Location" />
            </label>
            <label class="field">
              <select aria-label="All Categories">
                <option>All Categories</option>
                <option>Education</option>
                <option>Business &amp; Finance</option>
                <option>Government</option>
                <option>Healthcare</option>
                <option>Technology &amp; AI</option>
                <option>Workforce &amp; Labor</option>
              </select>
            </label>
            <button type="submit" class="btn btn-gold">Search Jobs</button>
          </form>
        </div>
      </div>
    </section>

    <!-- QUICK ACTIONS -->
    <section class="quick-actions">
      <div class="container">
        <div class="bar">
          <a class="quick-action" href="#">
            <div class="qa-icon">⇪</div>
            <div><b>Upload Resume</b><span>Let jobs come to you</span></div>
          </a>
          <a class="quick-action" href="#">
            <div class="qa-icon">✦</div>
            <div><b>AI Tweak My Resume <span style="color:var(--teal);font-size:11px;">FREE</span></b><span>Improve and stand out</span></div>
          </a>
          <a class="quick-action" href="#">
            <div class="qa-icon">💬</div>
            <div><b>Get Interview Tips</b><span>Prepare with confidence</span></div>
          </a>
          <a class="quick-action" href="#">
            <div class="qa-icon">📘</div>
            <div><b>Download Free Ebook</b><span>Real tools. Real careers.</span></div>
          </a>
          <a class="quick-action" href="#">
            <div class="qa-icon">☰</div>
            <div><b>Track My Applications</b><span>Stay organized</span></div>
          </a>
        </div>
      </div>
    </section>

    <!-- OPPORTUNITY VI -->
    <section class="block">
      <div class="container">
        <div class="section-head">
          <div>
            <h2>The Opportunity 6</h2>
            <p>Six powerful career worlds. Countless paths forward.</p>
          </div>
          <a href="#" class="section-link">View all jobs →</a>
        </div>

        <div class="vi-tabs" id="viTabs">
          <button class="vi-tab active" data-sector="education">
            <span class="vi-tab-icon">🎓</span><span>Education</span>
          </button>
          <button class="vi-tab" data-sector="business">
            <span class="vi-tab-icon">💼</span><span>Business & Finance</span>
          </button>
          <button class="vi-tab" data-sector="government">
            <span class="vi-tab-icon">🏛</span><span>Government</span>
          </button>
          <button class="vi-tab" data-sector="healthcare">
            <span class="vi-tab-icon">❤</span><span>Healthcare</span>
          </button>
          <button class="vi-tab" data-sector="tech">
            <span class="vi-tab-icon">⚙</span><span>Technology & AI</span>
          </button>
          <button class="vi-tab" data-sector="workforce">
            <span class="vi-tab-icon">👥</span><span>Workforce & Labor</span>
          </button>
        </div>

        <div class="vi-body">
          <div class="vi-feature">
            <div class="feature-photo"></div>
            <div class="feature-copy">
              <div class="eyebrow" style="font-size:11px;">Featured Sector</div>
              <h3 id="sectorHeadline">Build futures. Start with yours.</h3>
              <p id="sectorDescription">Explore jobs in education and training that shape lives and communities.</p>
              <a href="#" class="mini-link" id="sectorLink">View all Education jobs →</a>
            </div>
          </div>

          <div class="vi-jobs" id="viJobs">
            <article class="job-card">
              <span class="label">Featured</span>
              <h4>High School Teacher</h4>
              <div class="org">Baltimore City Public Schools<br>Baltimore, MD</div>
              <div class="job-meta">
                <span class="salary">$52K – $68K</span>
                <span class="badge-soft">Full-time</span>
              </div>
              <button class="btn btn-light btn-sm mt-10">View Job</button>
            </article>

            <article class="job-card">
              <h4>School Counselor</h4>
              <div class="org">Atlanta Public Schools<br>Atlanta, GA</div>
              <div class="job-meta">
                <span class="salary">$41K – $62K</span>
                <span class="badge-soft">Full-time</span>
              </div>
              <button class="btn btn-light btn-sm mt-10">View Job</button>
            </article>

            <article class="job-card">
              <h4>Instructional Designer</h4>
              <div class="org">University of Michigan<br>Ann Arbor, MI</div>
              <div class="job-meta">
                <span class="salary">$75K – $99K</span>
                <span class="badge-soft">Full-time</span>
              </div>
              <button class="btn btn-light btn-sm mt-10">View Job</button>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- MAP + NEARBY JOBS -->
    <section class="block">
      <div class="container">
        <div class="jobs-grid">
          <div class="map-panel">
            <div class="map-frame" aria-hidden="true"></div>
            <div class="pin p1">12</div>
            <div class="pin p2">18</div>
            <div class="pin p3">7</div>
            <div class="pin p4">5</div>
            <div class="pin p5">15</div>
            <div class="pin p6">9</div>
            <div class="pin p7">6</div>
            <div class="map-cta"><button class="btn btn-light btn-sm">View jobs near me</button></div>
          </div>

          <div class="nearby">
            <div class="nearby-head">
              <div>
                <h3>Jobs near you</h3>
                <p>Top opportunities in your area and across the country.</p>
              </div>
              <a href="#" class="section-link">View all jobs →</a>
            </div>

            <div class="nearby-list">
              <div class="nearby-item">
                <div class="nearby-logo">🩺</div>
                <div class="nearby-role"><b>Healthcare Data Analyst</b><span>Kaiser Permanente</span></div>
                <div class="nearby-loc">Oakland, CA (Hybrid)</div>
                <div class="apply-col"><span class="salary">$64K – $89K</span><button class="btn btn-gold btn-sm">Apply Now</button></div>
                <div class="bookmark">☆</div>
              </div>

              <div class="nearby-item">
                <div class="nearby-logo">🏛</div>
                <div class="nearby-role"><b>Policy Analyst</b><span>U.S. Department of Housing</span></div>
                <div class="nearby-loc">Washington, DC</div>
                <div class="apply-col"><span class="salary">$71K – $95K</span><button class="btn btn-gold btn-sm">Apply Now</button></div>
                <div class="bookmark">☆</div>
              </div>

              <div class="nearby-item">
                <div class="nearby-logo">⚙</div>
                <div class="nearby-role"><b>Software Engineer (AI/ML)</b><span>Guidehouse</span></div>
                <div class="nearby-loc">Remote</div>
                <div class="apply-col"><span class="salary">$98K – $135K</span><button class="btn btn-gold btn-sm">Apply Now</button></div>
                <div class="bookmark">☆</div>
              </div>

              <div class="nearby-item">
                <div class="nearby-logo">🛡</div>
                <div class="nearby-role"><b>Veterans Resources Specialist</b><span>City of Chicago</span></div>
                <div class="nearby-loc">Chicago, IL</div>
                <div class="apply-col"><span class="salary">$61K – $79K</span><button class="btn btn-gold btn-sm">Apply Now</button></div>
                <div class="bookmark">☆</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- HOTLIST -->
    <section class="block">
      <div class="container">
        <div class="hotlist">
          <div class="hotlist-head">
            <div class="hotlist-title">
              <div class="hot-badge">🔥 OP HOTLIST</div>
              <div class="small">Exclusive top opportunities from trusted employers.</div>
            </div>
            <a href="#" class="section-link" style="color:#ffcd69;">View all Hotlist →</a>
          </div>

          <div class="hot-cards">
            <article class="hot-card">
              <div class="seal">NAVY</div>
              <div>
                <div class="small">Hot</div>
                <h4>Chief of Staff</h4>
                <div class="small">U.S. Navy — Office of the Secretary</div>
                <div class="salary mt-8">$120K – $150K</div>
              </div>
            </article>

            <article class="hot-card">
              <div class="seal">DHS</div>
              <div>
                <div class="small">Hot</div>
                <h4>Cybersecurity Analyst</h4>
                <div class="small">U.S. Department of Homeland Security</div>
                <div class="salary mt-8">$88K – $120K</div>
              </div>
            </article>

            <article class="hot-card">
              <div class="seal">CMS</div>
              <div>
                <div class="small">Hot</div>
                <h4>Senior Data Scientist</h4>
                <div class="small">Centers for Medicare & Medicaid</div>
                <div class="salary mt-8">$115K – $156K</div>
              </div>
            </article>

            <article class="hot-card">
              <div class="seal">VA</div>
              <div>
                <div class="small">Hot</div>
                <h4>Nurse Practitioner</h4>
                <div class="small">Veterans Health Administration</div>
                <div class="salary mt-8">$126K – $165K</div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- TOOLS -->
    <section class="block">
      <div class="container">
        <div class="section-head">
          <div>
            <h2 style="font-size:38px">Resume Services & Career Tools</h2>
            <p>Everything you need to stand out and get hired.</p>
          </div>
          <a href="#" class="section-link">View all tools →</a>
        </div>

        <div class="tools-grid">
          <div class="tool"><div class="ico">📄</div><b>Resume Builder</b><span>Create a professional resume in minutes.</span></div>
          <div class="tool"><div class="ico">🔍</div><b>Resume Review</b><span>Expert feedback to improve your resume.</span></div>
          <div class="tool"><div class="ico">✦</div><b>AI Resume Tuning</b><span>Tailor your resume to stand out to ATS.</span></div>
          <div class="tool"><div class="ico">🎤</div><b>Interview Prep</b><span>Practice questions and expert tips.</span></div>
          <div class="tool"><div class="ico">💹</div><b>Salary Insights</b><span>Explore salary trends and data.</span></div>
          <div class="tool"><div class="ico">🧭</div><b>Career Assessment</b><span>Discover your best career match.</span></div>
          <div class="tool"><div class="ico">🔔</div><b>Job Alerts</b><span>Get new jobs delivered to you.</span></div>
        </div>
      </div>
    </section>

    <!-- RESOURCE -->
    <section class="block">
      <div class="container">
        <div class="resource">
          <div class="resource-photo"></div>
          <div class="resource-copy">
            <div>
              <div class="eyebrow" style="font-size:11px;color:var(--gold)"><span style="display:none"></span>Free Resource</div>
              <h3>How to Ace Your Interview</h3>
              <p>Proven strategies, sample answers, and insider tips to help you walk in prepared and walk out hired.</p>
              <button class="btn btn-gold">Download Free Ebook</button>
              <div class="mt-16"><a href="#" class="mini-link">View all resources →</a></div>
            </div>

            <div class="book-mock">
              <div class="book">
                <div class="book-title">How to Ace Your Interview</div>
                <p style="margin:16px 0 0;color:var(--muted);line-height:1.55;font-size:14px;">Top tips to confidently land your next role.</p>
                <div style="position:absolute;left:18px;bottom:18px;font-size:12px;color:var(--muted)">opportunitypost.org</div>
              </div>

              <div class="bullet-list">
                <div class="row"><div class="check">✓</div><div>Expert tips and frameworks</div></div>
                <div class="row"><div class="check">✓</div><div>Sample answers for common questions</div></div>
                <div class="row"><div class="check">✓</div><div>What to do before, during & after</div></div>
                <div class="row"><div class="check">✓</div><div>Bonus: Red flags to avoid</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FIRST BRIEFCASE -->
    <section class="block">
      <div class="container">
        <div class="briefcase">
          <div class="briefcase-grid">
            <div class="brief-intro">
              <div class="eyebrow">First Briefcase</div>
              <h3>Kickstart your career journey.</h3>
              <p>Entry-level jobs, internships, and apprenticeships to help you build experience and confidence.</p>
            </div>

            <div class="brief-item">
              <div class="ico">👜</div>
              <b>Internships</b>
              <span>Paid & unpaid opportunities.</span>
            </div>
            <div class="brief-item">
              <div class="ico">🛤</div>
              <b>Pathway Programs</b>
              <span>Launch your career with support.</span>
            </div>
            <div class="brief-item">
              <div class="ico">🏫</div>
              <b>Campus Recruiting</b>
              <span>Connect with top employers.</span>
            </div>
            <div class="brief-item">
              <div class="ico">🧠</div>
              <b>Assessment Starter</b>
              <span>Discover your best first step.</span>
            </div>

            <div class="brief-partner">
              <div class="ico">EF</div>
              <b>EnrollForge</b>
              <span>Proud partner for student pathways.</span>
              <div class="mt-16"><a href="#" class="mini-link">Learn More →</a></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- EMPLOYER -->
    <section class="block">
      <div class="container">
        <div class="employer-grid">
          <div class="employer-copy">
            <div class="eyebrow">For Employers</div>
            <h3>Employer Command Center</h3>
            <p>Smarter hiring. Better teams. Stronger impact.</p>

            <div class="check-list">
              <div class="item"><div class="dot">✓</div><div>Post jobs and reach qualified, diverse talent</div></div>
              <div class="item"><div class="dot">✓</div><div>AI-powered matching and candidate insights</div></div>
              <div class="item"><div class="dot">✓</div><div>Track applicants and manage your pipeline</div></div>
              <div class="item"><div class="dot">✓</div><div>Premium visibility across our platform</div></div>
            </div>

            <div style="display:flex;gap:10px;flex-wrap:wrap;">
              <button class="btn btn-gold">Post a Job</button>
              <button class="btn btn-light">Learn More</button>
            </div>
          </div>

          <div class="employer-board">
            <div class="dash-title">
              <span>Your Hiring Dashboard</span>
              <span class="muted" style="font-size:12px;">Live</span>
            </div>

            <div class="metrics">
              <div class="metric"><span>Total Applicants</span><b>241</b></div>
              <div class="metric"><span>Screened</span><b>132</b></div>
              <div class="metric"><span>Interviews</span><b>56</b></div>
              <div class="metric"><span>Hired</span><b>28</b></div>
            </div>

            <div class="pipeline">
              <div class="pipeline-head">
                <div>
                  <b style="display:block;font-size:16px;margin-bottom:4px;">Application Pipeline</b>
                  <span class="muted" style="font-size:13px;">Real-time movement from apply to hire.</span>
                </div>
                <div class="legend">
                  <div class="line"><span class="swatch" style="background:#2c9ca0"></span>Policy Analyst</div>
                  <div class="line"><span class="swatch" style="background:#89e1db"></span>Data Analyst</div>
                  <div class="line"><span class="swatch" style="background:#d89a2b"></span>Program Manager</div>
                </div>
              </div>

              <div class="bars">
                <div class="bar-col"><div class="bar" style="height:92px"></div><div>Applied<br><b style="color:var(--navy)">492</b></div></div>
                <div class="bar-col"><div class="bar" style="height:68px"></div><div>Screening<br><b style="color:var(--navy)">132</b></div></div>
                <div class="bar-col"><div class="bar" style="height:48px"></div><div>Interview<br><b style="color:var(--navy)">56</b></div></div>
                <div class="bar-col"><div class="bar" style="height:28px"></div><div>Offered<br><b style="color:var(--navy)">26</b></div></div>
                <div class="bar-col"><div class="bar" style="height:18px"></div><div>Hired<br><b style="color:var(--navy)">18</b></div></div>
              </div>
            </div>
          </div>

          <div class="employer-photo"></div>
        </div>
      </div>
    </section>

    <!-- TRUST -->
    <section class="block">
      <div class="container">
        <div class="trust-grid">
          <div class="trust-intro">
            <h3>Trusted by job seekers and leading employers</h3>
            <p>Real people. Real impact.</p>
            <a href="#" class="mini-link">Read more stories →</a>
          </div>

          <article class="quote-card">
            <div class="person">
              <div class="avatar"></div>
              <div class="quote-meta"><b>Jasmine R.</b><span>Data Analyst, Chicago, IL</span></div>
            </div>
            <blockquote>“Opportunity Post helped me land a role that aligns with my values and future.”</blockquote>
          </article>

          <article class="quote-card">
            <div class="person">
              <div class="avatar"></div>
              <div class="quote-meta"><b>Marcus T.</b><span>Program Manager, Atlanta, GA</span></div>
            </div>
            <blockquote>“The tools and resources gave me the confidence to interview like a pro.”</blockquote>
          </article>

          <article class="quote-card">
            <div class="person">
              <div class="avatar"></div>
              <div class="quote-meta"><b>Angela P.</b><span>Talent Director, Nonprofit</span></div>
            </div>
            <blockquote>“We found incredible talent through Opportunity Post’s platform and support.”</blockquote>
          </article>

          <div class="logos-card">
            <h4>Top employers hiring</h4>
            <div class="logos">
              <div class="logo-box">Kaiser Permanente</div>
              <div class="logo-box">U.S. Navy</div>
              <div class="logo-box">amazon</div>
              <div class="logo-box">Microsoft</div>
              <div class="logo-box">Johns Hopkins</div>
              <div class="logo-box">City of Chicago</div>
            </div>
            <div class="mt-16"><a href="#" class="mini-link">View all employers →</a></div>
          </div>
        </div>
      </div>
    </section>
  `;
const LIGHTBOX_HTML = `<div id="ch-lightbox" onclick="if(event.target===this)this.style.display='none'">
  <div class="ch-lbx-card">
    <button class="ch-lbx-close" onclick="document.getElementById('ch-lightbox').style.display='none'">×</button>
    <div id="ch-lbx-content"></div>
  </div>
</div>`;
const SCRIPT_SECTORS = `(function() {
  var raw = window.__chApiBase || '';
  var API = raw.length && raw[raw.length-1] === '/' ? raw.slice(0,-1) : raw;

  var SECTOR_MAP = {
    education:  { cat:'Education',  headline:'Build futures. Start with yours.',         desc:'Explore jobs in education and training that shape lives and communities.',                 link:'View all Education jobs \u2192' },
    business:   { cat:'Business',   headline:'Build wealth. Move industries.',           desc:'Explore business, finance, operations, and strategic growth roles across the country.',    link:'View all Business & Finance jobs \u2192' },
    government: { cat:'Government', headline:'Serve with purpose. Lead with impact.',    desc:'Find public-sector, policy, administration, and civic leadership roles that matter.',      link:'View all Government jobs \u2192' },
    healthcare: { cat:'Healthcare', headline:'Improve care. Strengthen lives.',          desc:'See clinical, administrative, data, and healthcare operations roles nationwide.',           link:'View all Healthcare jobs \u2192' },
    tech:       { cat:'Technology', headline:"Shape tomorrow. Engineer what's next.",    desc:'Explore AI, software, data, cybersecurity, and product roles from top employers.',         link:'View all Technology & AI jobs \u2192' },
    workforce:  { cat:'Workforce',  headline:'Support workers. Strengthen communities.', desc:'Workforce development, labor strategy, career pathways, and community opportunity roles.', link:'View all Workforce & Labor jobs \u2192' }
  };

  var jobsWrap   = document.getElementById('viJobs');
  var headlineEl = document.getElementById('sectorHeadline');
  var descEl     = document.getElementById('sectorDescription');
  var linkEl     = document.getElementById('sectorLink');

  function wtLabel(wt) {
    var m = { full_time:'Full-time', part_time:'Part-time', contract:'Contract', internship:'Internship', freelance:'Freelance', temporary:'Temporary' };
    return (wt && m[wt]) ? m[wt] : 'Full-time';
  }

  function logoHtml(job) {
    var initDiv = '<div style="width:32px;height:32px;border-radius:8px;background:#f4f7fb;display:grid;place-items:center;font-weight:800;font-size:12px;color:var(--navy);flex:0 0 auto">' + (job.logo_initial||'OP') + '</div>';
    if (!job.employer_logo_url) return initDiv;
    var hiddenInit = '<div style="width:32px;height:32px;border-radius:8px;background:#f4f7fb;display:none;place-items:center;font-weight:800;font-size:12px;color:var(--navy);flex:0 0 auto">' + (job.logo_initial||'OP') + '</div>';
    return '<img data-logo="1" src="' + job.employer_logo_url + '" alt="" style="width:32px;height:32px;border-radius:8px;object-fit:contain;background:#f4f7fb;border:1px solid #edf2f7;flex:0 0 auto">' + hiddenInit;
  }

  function cardHtml(job) {
    return '<a href="/career-hub/' + job.id + '" style="text-decoration:none;color:inherit">' +
      '<article class="job-card">' +
      '<div style="display:flex;gap:8px;align-items:center;margin-bottom:4px">' + logoHtml(job) +
      '<span style="font-size:11px;color:var(--muted);font-weight:700;text-transform:uppercase;letter-spacing:.06em;line-height:1">' + (job.category||'') + '</span></div>' +
      '<h4>' + (job.title||'') + '</h4>' +
      '<div class="org">' + (job.organization||'') + (job.location ? '<br>' + job.location : '') + '</div>' +
      '<div class="job-meta">' +
      '<span class="salary">' + (job.salary_range||'\u2014') + '</span>' +
      '<span class="badge-soft">' + wtLabel(job.work_type) + '</span>' +
      '</div>' +
      '<button class="btn btn-light btn-sm mt-10">View Job</button>' +
      '</article></a>';
  }

  function setLogoFallbacks() {
    jobsWrap.querySelectorAll('img[data-logo]').forEach(function(img) {
      var next = img.nextElementSibling;
      img.onerror = function() {
        this.style.display = 'none';
        if (next) next.style.display = 'grid';
      };
    });
  }

  function skeleton() {
    var s = '<article class="job-card" style="pointer-events:none">' +
      '<div style="height:32px;width:32px;border-radius:8px;background:#eef2f7;margin-bottom:10px"></div>' +
      '<div style="height:18px;border-radius:6px;background:#f0f4f8;margin-bottom:10px;width:80%"></div>' +
      '<div style="height:14px;border-radius:6px;background:#f5f7fa;margin-bottom:6px;width:70%"></div>' +
      '<div style="height:14px;border-radius:6px;background:#f5f7fa;width:50%"></div>' +
      '</article>';
    return s + s + s;
  }

  function empty(msg) {
    return '<div style="grid-column:1/-1;padding:32px;text-align:center;color:var(--muted)">' + msg + '</div>';
  }

  async function fetchAndRender(params) {
    jobsWrap.innerHTML = skeleton();
    try {
      var qs = Object.keys(params).map(function(k){ return encodeURIComponent(k)+'='+encodeURIComponent(params[k]); }).join('&');
      var res = await fetch(API + '/api/jb/jobs?' + qs);
      if (!res.ok) throw new Error('fetch failed');
      var data = await res.json();
      var jobs = (data.jobs||[]).slice(0,3);
      jobsWrap.innerHTML = jobs.length ? jobs.map(cardHtml).join('') : empty('No jobs found in this category yet.');
      setLogoFallbacks();
    } catch(e) {
      jobsWrap.innerHTML = empty('Could not load jobs. Please try again.');
    }
  }

  async function searchAndRender(q) {
    jobsWrap.innerHTML = skeleton();
    try {
      var res = await fetch(API + '/api/jb/jobs/search?q=' + encodeURIComponent(q) + '&limit=20');
      if (!res.ok) throw new Error('search failed');
      var data = await res.json();
      var jobs = (data.jobs||[]).slice(0,3);
      jobsWrap.innerHTML = jobs.length ? jobs.map(cardHtml).join('') : empty('No results found. Try a different keyword.');
      setLogoFallbacks();
    } catch(e) {
      jobsWrap.innerHTML = empty('Could not load results. Please try again.');
    }
  }

  function activateSector(key) {
    var s = SECTOR_MAP[key] || SECTOR_MAP.education;
    headlineEl.textContent = s.headline;
    descEl.textContent = s.desc;
    linkEl.textContent = s.link;
    fetchAndRender({ category: s.cat, limit: 20 });
  }

  document.querySelectorAll('.vi-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.vi-tab').forEach(function(t){ t.classList.remove('active'); });
      tab.classList.add('active');
      activateSector(tab.dataset.sector);
    });
  });

  var searchForm = document.querySelector('.hero-search');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var inp = searchForm.querySelector('input[type="text"]');
      var q = inp ? inp.value.trim() : '';
      if (q.length >= 1) {
        document.querySelectorAll('.vi-tab').forEach(function(t){ t.classList.remove('active'); });
        headlineEl.textContent = 'Search Results';
        descEl.textContent = 'Showing results for "' + q + '".';
        linkEl.textContent = 'View all matching jobs \u2192';
        searchAndRender(q);
        var vi = document.querySelector('.vi-body');
        if (vi) vi.scrollIntoView({ behavior:'smooth', block:'start' });
      } else {
        activateSector('education');
        document.querySelectorAll('.vi-tab').forEach(function(t){ t.classList.remove('active'); });
        var ed = document.querySelector('.vi-tab[data-sector="education"]');
        if (ed) ed.classList.add('active');
      }
    });
  }

  activateSector('education');
})();`;

const SCRIPT_AUTH_LBX = `(function() {

const lbx = document.getElementById('ch-lightbox');
const content = document.getElementById('ch-lbx-content');

const forms = {
  'seeker-register': {
    title: 'Create Your Account',
    sub: 'Find curated jobs matched to your goals.',
    tabs: ['Job Seeker', 'Employer'],
    active: 0,
    fields: ['First Name', 'Last Name', 'Email Address', 'Password'],
    btn: 'Create Seeker Account →',
    switch: 'Already have an account? <a onclick="showForm(\\'signin\\')">Sign In</a>'
  },
  'employer-register': {
    title: 'Post Your First Job',
    sub: 'Reach 110,000+ qualified professionals.',
    tabs: ['Job Seeker', 'Employer'],
    active: 1,
    fields: ['Company Name', 'Contact Name', 'Work Email', 'Password'],
    btn: 'Create Employer Account →',
    switch: 'Already have an account? <a onclick="showForm(\\'signin\\')">Sign In</a>'
  },
  'signin': {
    title: 'Welcome Back',
    sub: 'Sign in to your Career Hub account.',
    tabs: ['Job Seeker', 'Employer'],
    active: 0,
    fields: ['Email Address', 'Password'],
    btn: 'Sign In →',
    switch: 'New to Career Hub? <a onclick="showForm(\\'seeker-register\\')">Create an account</a>'
  }
};

function showForm(mode) {
  const f = forms[mode];
  lbx.dataset.mode = mode;
  content.innerHTML = \`
    <div class="ch-lbx-title">\${f.title}</div>
    <div class="ch-lbx-sub">\${f.sub}</div>
    <div class="ch-lbx-tabs">
      \${f.tabs.map((t,i) => \`<button class="ch-lbx-tab \${i===f.active?'active':''}" onclick="showForm('\${i===0?'seeker-register':'employer-register'}')">\${t}</button>\`).join('')}
    </div>
    \${f.fields.map(field => \`
      <div class="ch-lbx-field">
        <label>\${field}</label>
        <input type="\${field.toLowerCase().includes('password')?'password':field.toLowerCase().includes('email')?'email':'text'}" placeholder="\${field}" />
      </div>
    \`).join('')}
    <button class="ch-lbx-btn">\${f.btn}</button>
    <div class="ch-lbx-switch">\${f.switch}</div>
  \`;
  lbx.style.display = 'flex';
}

// Auto-render on open
const observer = new MutationObserver(() => {
  if(lbx.style.display === 'flex' && !content.innerHTML.trim()) {
    showForm(lbx.dataset.mode || 'seeker-register');
  }
});
observer.observe(lbx, {attributes: true, attributeFilter: ['style']});

document.querySelectorAll('.auth-role-btn, .auth-signin-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    showForm(lbx.dataset.mode || 'seeker-register');
  });
});

window.showForm = showForm;
})();`;
const SCRIPT_AUTH_WIRING = `(function() {
  var API = (window.__chApiBase || '').replace(/\\/$/, '');

  function collectFields(c) {
    var r = {};
    c.querySelectorAll('input').forEach(function(i) {
      var p = (i.placeholder||'').toLowerCase().trim();
      if (p==='first name') r.first_name=i.value;
      else if (p==='last name') r.last_name=i.value;
      else if (p==='email address') r.email=i.value;
      else if (p==='work email') r.contact_email=i.value;
      else if (p==='password') r.password=i.value;
      else if (p==='company name') r.company_name=i.value;
      else if (p==='contact name') r.contact_name=i.value;
    });
    return r;
  }

  function showMsg(c, msg, isErr) {
    var el = c.querySelector('.ch-auth-msg');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ch-auth-msg';
      el.style.cssText = 'text-align:center;font-size:13px;margin-top:10px;padding:8px 12px;border-radius:8px;';
      var btn = c.querySelector('.ch-lbx-btn');
      if (btn) btn.insertAdjacentElement('afterend', el); else c.appendChild(el);
    }
    el.style.color = isErr ? '#7f1d1d' : '#14532d';
    el.style.background = isErr ? '#fee2e2' : '#dcfce7';
    el.textContent = msg;
  }

  function saveAndRedirect(data) {
    localStorage.setItem('jb_token', data.access_token);
    localStorage.setItem('jb_role', data.role);
    localStorage.setItem('jb_user', JSON.stringify({user_id:data.user_id,role:data.role}));
    window.location.href = (data.role==='employer') ? '/employer/dashboard' : '/seeker/dashboard';
  }

  async function doSubmit(mode, c) {
    var btn = c.querySelector('.ch-lbx-btn');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled=true; btn.textContent='Please wait...'; }
    var old = c.querySelector('.ch-auth-msg'); if (old) old.remove();
    try {
      var f = collectFields(c), res, body;
      if (mode==='seeker-register') {
        body = {first_name:f.first_name||'',last_name:f.last_name||'',email:f.email||'',password:f.password||''};
        res = await fetch(API+'/api/jb/seeker/register',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      } else if (mode==='employer-register') {
        body = {company_name:f.company_name||'',contact_name:f.contact_name||'',contact_email:f.contact_email||'',password:f.password||''};
        res = await fetch(API+'/api/jb/employer/register',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      } else {
        body = {email:f.email||'',password:f.password||''};
        res = await fetch(API+'/api/jb/seeker/login',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
        if (res.status===401) res = await fetch(API+'/api/jb/employer/login',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      }
      var data = await res.json();
      if (!res.ok) throw new Error(data.detail||'Something went wrong.');
      saveAndRedirect(data);
    } catch(err) {
      showMsg(c, err.message||'Something went wrong. Please try again.', true);
      if (btn) { btn.disabled=false; btn.textContent=orig; }
    }
  }

  var lbxEl = document.getElementById('ch-lightbox');
  if (lbxEl) {
    lbxEl.addEventListener('click', function(e) {
      var t = e.target;
      if (t && t.classList.contains('ch-lbx-btn') && !t.disabled) {
        var lbx=document.getElementById('ch-lightbox'), cont=document.getElementById('ch-lbx-content');
        if (lbx && cont) doSubmit(lbx.dataset.mode, cont);
      }
    });
  }
})();`;

export default function CareerHubPage() {
  useLayoutEffect(() => {
    if (!document.getElementById('ch-handoff-fonts')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = FONT_HREF; link.id = 'ch-handoff-fonts';
      document.head.appendChild(link);
    }
    if (!document.getElementById('ch-handoff-style')) {
      const style = document.createElement('style');
      style.id = 'ch-handoff-style'; style.textContent = ARTIFACT_STYLE;
      document.head.appendChild(style);
    }
    return () => {
      document.getElementById('ch-handoff-fonts')?.remove();
      document.getElementById('ch-handoff-style')?.remove();
    };
  }, []);

  useEffect(() => {
    if (document.getElementById('ch-scripts-injected')) return;
    const marker = document.createElement('span');
    marker.id = 'ch-scripts-injected'; marker.style.display = 'none';
    document.body.appendChild(marker);

    window.__chApiBase = process.env.REACT_APP_BACKEND_URL || '';

    const s1 = document.createElement('script');
    s1.textContent = SCRIPT_SECTORS; document.body.appendChild(s1);

    const s2 = document.createElement('script');
    s2.textContent = SCRIPT_AUTH_LBX; document.body.appendChild(s2);

    const s3 = document.createElement('script');
    s3.textContent = SCRIPT_AUTH_WIRING; document.body.appendChild(s3);

    return () => {
      document.getElementById('ch-scripts-injected')?.remove();
      s1.remove(); s2.remove(); s3.remove();
      delete window.__chApiBase;
    };
  }, []);

  return (
    <div
      data-testid="career-hub-page"
      dangerouslySetInnerHTML={{ __html: MAIN_HTML + '\n' + LIGHTBOX_HTML }}
    />
  );
}
